module.exports = __webpack_public_path__ + "static/media/ODS13.62c1f245.svg";